import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
	enable: enableBodyScroll,
	disable: disableBodyScroll,
};